export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',

  OTP_VALIDITY: 15,
  TOKEN_VALIDITY: 30,
  PLAN_EXPIRY_WARNING: 7,
  REQUEST_TIMEOUT: 30000,

  ENDPOINTS: {
    REQUEST_LOGIN_CODE: '/auth/request-login-code',
    VERIFY_LOGIN_CODE: '/auth/verify-login-code',
    REQUEST_REGISTER_CODES: '/auth/request-register-codes',
    VERIFY_REGISTER_CODES: '/auth/verify-register-codes',
    LOGOUT: '/auth/logout',
    VERIFY_TOKEN: '/auth/verify-token',
    REGISTER_FREE_TRIAL: '/auth/register-free-trial',

    INITIATE_PAYMENT: '/payment/initiate',
    VERIFY_PAYMENT: '/payment/verify',

    RENEW_SUBSCRIPTION: '/subscription/renew',
    CHECK_SUBSCRIPTION: '/subscription/check',

    // Managers
    ADD_MANAGER: '/managers/add',
    GET_MANAGERS: '/managers/list',
    UPDATE_MANAGER: '/managers/update',
    DELETE_MANAGER: '/managers/delete',
    REQUEST_MANAGER_OTP: '/managers/request-otp',
    VERIFY_MANAGER_OTP: '/managers/verify-otp',
  },

  PLANS: {
    ESSAI: {
      id: 'essai',
      name: 'Plan Découverte',
      price: 0,
      currency: 'GNF',
      maxSessions: 1,
      description: '1 utilisateur connecté simultanément',
    },
    BASIC: {
      id: 'basic',
      name: 'Plan Basique',
      price: 50000,
      currency: 'GNF',
      maxSessions: 1,
      description: '1 utilisateur connecté simultanément',
    },
    STANDARD: {
      id: 'standard',
      name: 'Plan Standard',
      price: 150000,
      currency: 'GNF',
      maxSessions: 5,
      description: "Jusqu'à 5 utilisateurs connectés simultanément",
    },
    PREMIUM: {
      id: 'premium',
      name: 'Plan Premium',
      price: 350000,
      currency: 'GNF',
      maxSessions: 25,
      description: "Jusqu'à 25 utilisateurs connectés simultanément",
    },
  },

  PAYMENT_METHODS: {
    ORANGE_MONEY: {
      id: 'orange_money',
      name: 'Orange Money',
      icon: '🟠',
    },
    CARD: {
      id: 'card',
      name: 'Carte Bancaire',
      description: 'Visa ou MasterCard',
      icon: '💳',
    },
  },
}

export default API_CONFIG
